<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg {width} {height} viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M15.6374 6.63749L14.9984 6.05213L8.49756 0L1.99799 6.05098L1.35893 6.63634C-0.452977 8.296 -0.452977 10.9955 1.35893 12.6873C2.24734 13.5011 3.41895 13.9235 4.5918 13.9235C5.79974 13.9235 6.97134 13.5011 7.85975 12.6873L8.49881 12.0687L9.13786 12.6873C10.0614 13.5011 11.233 13.9235 12.4058 13.9235C13.5774 13.9235 14.7503 13.5011 15.6738 12.6873C17.4481 10.9967 17.4481 8.296 15.6374 6.63749ZM11.5876 16.1375L8.53264 13.2738L5.44262 16.1375L8.53264 19L11.5876 16.1375ZM12.085 8.75166L11.7655 9.04434L8.49756 12.0698L5.2296 9.04434L4.91007 8.75166C4.02166 7.90576 4.02166 6.53878 4.91007 5.69288C5.37245 5.30265 5.94008 5.07539 6.54405 5.07539C7.14802 5.07539 7.71565 5.30265 8.17803 5.69403L8.49756 6.01885L8.81708 5.69403C9.27946 5.30379 9.88217 5.07539 10.4861 5.07539C11.055 5.07539 11.6577 5.30265 12.1201 5.69403C12.9734 6.53993 12.9734 7.90576 12.085 8.75166Z"
		{fill}
	/>
	<defs>
		<linearGradient
			id="paint0_linear_7534_54987"
			x1="7.91379"
			y1="-2.03571"
			x2="24.1039"
			y2="16.3214"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#3EFFB4" />
			<stop offset="1" stop-color="#01D180" />
		</linearGradient>
	</defs>
</svg>
